<ng-container *transloco="let t">
  <form
    [id]="endOrderFormId()"
    class="end-order-form"
    #form="ngForm"
    #formElement
    (keydown.enter)="$event.preventDefault()"
    (ngSubmit)="onSubmit($event)"
  >
    <!-- Personal Information -->
    <pxw-end-order-customer-fields
      [isFormSubmitted]="isFormSubmitted()"
      [personalInformationFieldsRequired]="personalInformationFieldsRequired()"
      [(name)]="name"
      [(phone)]="phone"
    />

    <!-- Custom Fields -->
    <pxw-end-order-custom-fields
      [isFormSubmitted]="isFormSubmitted()"
      [customFields]="checkoutData().customFields || []"
      [(customFieldDetailValues)]="customFieldDetailValues"
    />

    <hr class="ui-separator ui-separator--sm" />

    <!-- Shipping Options -->
    @if (shouldDisplayShippingOptions()) {
      <pxw-end-order-shipping-option-fields
        [isFormSubmitted]="isFormSubmitted()"
        [workerServicesUrl]="workerServicesUrl()"
        [countryCodes]="countryCodes()"
        [apiUrl]="apiUrl()"
        [checkoutData]="checkoutData()"
        [establishment]="establishment()"
        [totalAmountWithDiscount]="endOrderTotals().totalAmountWithDiscount || 0"
        [cartItems]="cartItems()"
        [availableLogisticIntegrations]="availableLogisticIntegrations()"
        [name]="name()"
        [phone]="phone()"
        [(shippingOptionType)]="shippingOptionType"
        [(address)]="address"
        [(tableNumber)]="tableNumber"
        [(shippingCostResponse)]="shippingCostResponse"
        (selectedShippingOptionChange)="shippingOption.set($event)"
      />

      <!-- Email Field for Parcel Tracking -->
      @if (shouldDisplayParcelTrackingEmail()) {
        <pxw-input-text
          name="email"
          [label]="t('endOrder.parcelTrackingEmailLabel')"
          [placeholder]="t('endOrder.parcelTrackingEmailPlaceholder')"
          [helper]="t('endOrder.parcelTrackingEmailHelper')"
          [(ngModel)]="email"
          [displayErrors]="isFormSubmitted()"
          required
          email
          [messages]="{
            required: t('endOrder.parcelTrackingEmailRequired'),
            email: t('endOrder.parcelTrackingEmailInvalid'),
          }"
        />
      }

      <hr class="ui-separator ui-separator--sm" />
    }
    <!--############################################################################-->

    <!-- Payment Methods -->
    @let enabledPaymentMethodOptions = enabledPaymentMethods();

    @if (enabledPaymentMethodOptions && enabledPaymentMethodOptions.length > 0) {
      <pxw-end-order-payment-methods-fields
        [isFormSubmitted]="isFormSubmitted()"
        [paymentMethods]="enabledPaymentMethodOptions"
        [orderFinalAmount]="endOrderTotals().finalAmount || 0"
        [paymentMethod]="paymentMethod()"
        (paymentMethodChange)="onUpdatePaymentMethod($event)"
        [(howMuch)]="howMuch"
        [displayHowMuchField]="displayHowMuchField()"
        [displayLinkInfo]="true"
      />
      <hr class="ui-separator ui-separator--sm" />
    }
    <!--############################################################################-->

    <!-- Coupon -->
    @if (establishment().catalogConfiguration.enableCoupons) {
      <pxw-end-order-coupon-fields
        [isFormSubmitted]="isFormSubmitted()"
        [(couponConfigurationSnapshot)]="couponConfigurationSnapshot"
        [(couponCode)]="couponCode"
        [cartItems]="cartItems()"
        [paymentMethods]="enabledPaymentMethodOptions"
        [paymentMethod]="paymentMethod()"
        [categories]="categories()"
        [productTags]="productTags()"
        [establishmentId]="establishment().id"
        [couponDiscount]="endOrderTotals().couponDiscount || null"
      />
      <hr class="ui-separator ui-separator--sm" />
    }
    <!--############################################################################-->

    <!-- Billing Information-->
    @if (displayBillingFields()) {
      <pxw-end-order-billing-fields
        [isFormSubmitted]="isFormSubmitted()"
        [(requestBilling)]="requestBilling"
        [(billingInformation)]="billingInformation"
        [isAdminMode]="isAdminMode()"
      />
    }
    <!--############################################################################-->

    <!-- Food Bank Donation Section (Commented Out)
    @if (enableFoodBankDonation()) {
      <hr class="ui-separator ui-separator--sm" />
      <pxw-alert
        class="food-bank-donation__alert"
        type="success"
        size="sm"
        display="inline-block"
        style="margin: 0 0 2em; padding: 0.2em 0"
      >
        <strong> ¡Hoy podés alimentar un niño/a! </strong>
        <pxw-icon icon="donation" #customIcon size="md" />

        <ng-template #alertDetails>
          <pxw-input-checkbox
            name="hasFoodBankDonation"
            [legend]="
              'Quiero donar $' +
              foodBankDonationAmount +
              ' para alimentar a quienes más lo necesitan con el Banco de Alimentos de Córdoba. Cada plato cuenta en nuestra lucha contra el hambre.'
            "
            [(ngModel)]="bankFoodDonationChecked"
          />
          <div class="food-bank-donation">
            <strong
              class="food-bank-donation__more-information"
              (click)="onToggleBankFoodDonationMoreInformation()"
            >
              [{{ bankFoodDonationMoreInformation() ? '-' : '+' }}] ¿Qué es el Banco de Alimentos?
            </strong>
            @if (bankFoodDonationMoreInformation()) {
              <div class="food-bank-donation__description">
                <p>
                  La Fundación Banco de Alimentos Córdoba es una ONG que trabaja arduamente para
                  reducir el hambre mediante el recupero de alimentos, asistiendo actualmente a más
                  de 90.000 personas a través de 560 organizaciones sociales. Con tu ayuda, podemos
                  hacer una diferencia aún mayor.
                </p>
                <p>
                  <a href="https://bancodealimentoscba.org.ar/" target="_blank">
                    Para más información sobre cómo tu contribución ayuda, podés visitar el sitio
                    web de la fundación haciendo click acá.
                  </a>
                </p>
              </div>
            }
          </div>
        </ng-template>
      </pxw-alert>
    }
    -->
    <!--############################################################################-->
  </form>

  <app-coupon-validation-invalid-payment-method-dialog />
</ng-container>
